module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_4.992e7962.png";